export function BringItAll() {
  return (
    <section data-testid="bring-it-all-section" className="relative overflow-hidden bg-[#EFF5F4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[44px] md:pt-[66px] pb-[38px] md:pb-[55px]">
        <div className="reveal">
          <h2 className="font-display text-[34px] sm:text-[44px] lg:text-[52px] leading-[1.08] tracking-tight text-[#1C1917] max-w-[680px] mb-8">
            Whatever&rsquo;s Been Waiting&hellip;Bring It.
          </h2>

          <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed max-w-[560px]">
            Whether it&rsquo;s planning social media, filing paperwork, writing, packing for a trip, organizing photos, finishing a presentation, updating your r&eacute;sum&eacute; or tackling the task that&rsquo;s been quietly following you around&hellip;
          </p>

          <p className="font-display text-[64px] sm:text-[76px] lg:text-[150px] leading-[0.85] text-[#159E9A] tracking-tight my-4 md:my-6 lg:-ml-1">
            Bring it.
          </p>

          <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed max-w-[560px] ml-auto text-right mb-12">
            For ninety minutes, you&rsquo;ll have protected time, gentle accountability and a room full of people choosing progress alongside you.
          </p>

          <div className="max-w-[660px] ml-auto flex items-stretch justify-end gap-5 lg:gap-7">
            <div className="text-right">
              <p className="text-[22px] leading-[28px] text-[#57534E] mb-1">
                You don&rsquo;t have to be working on the same thing.
              </p>
              <p className="font-display text-2xl md:text-[34px] text-[#1C1917] leading-snug">
                You just have to be working on your thing.
              </p>
            </div>
            <div className="w-[2px] flex-shrink-0 self-stretch bg-[#FF5A4F]" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
}
